import React, { Fragment, memo, useCallback } from 'react'
import tw from 'twin.macro'
import { useSelector } from 'react-redux'
import { getCurrentCollectDataStep } from 'src/selectors/collectData'
import { useYardstik } from 'src/hooks/useYardstik'
import { InfoContainer } from '../shared/InfoContainer'
import { BGCCollectDataStep } from 'src/interfaces/collectData'

const BGCProceedWithYardstikComponent = () => {
  const currentStep = useSelector(getCurrentCollectDataStep) as BGCCollectDataStep

  const { startYardstik, YardstikView } = useYardstik()

  const showYardstik = useCallback(() => {
    startYardstik(currentStep.id)
  }, [currentStep.id])

  return (
    <Fragment>
      <InfoContainer
        className={tw`mt-4`}
        actionText="Tap to proceed with Yardstik"
        onClick={showYardstik}
        dataTestId="contractors-onboarding-bgc-yardstik-info-btn"
      >
        Please note: If you are only able to upload one document out of the two, please proceed with
        the Yardstik process.
      </InfoContainer>
      <YardstikView />
    </Fragment>
  )
}

export const BGCProceedWithYardstik = memo(BGCProceedWithYardstikComponent)
